import { render, staticRenderFns } from "./ActiveExchangeCourse.vue?vue&type=template&id=0f5def5a&"
import script from "./ActiveExchangeCourse.vue?vue&type=script&lang=js&"
export * from "./ActiveExchangeCourse.vue?vue&type=script&lang=js&"
import style0 from "./ActiveExchangeCourse.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports